/**
 * @generated SignedSource<<ff34dac37175a602a0c38a51c1ff291f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStoryBlockHomeV2QueueItemsEdge$data = ReadonlyArray<{
  readonly node: {
    readonly entityId?: string;
    readonly urlAlias?: string;
    readonly " $fragmentSpreads": FragmentRefs<"contentCoverImageContent" | "entityLink" | "homeSecondaryV2ContentItemContent">;
  };
  readonly " $fragmentType": "sectionStoryBlockHomeV2QueueItemsEdge";
}>;
export type sectionStoryBlockHomeV2QueueItemsEdge$key = ReadonlyArray<{
  readonly " $data"?: sectionStoryBlockHomeV2QueueItemsEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionStoryBlockHomeV2QueueItemsEdge">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "sectionStoryBlockHomeV2QueueItemsEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlAlias",
              "storageKey": null
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "withSize1200x800",
                  "value": true
                },
                {
                  "kind": "Literal",
                  "name": "withSize540x360",
                  "value": true
                }
              ],
              "kind": "FragmentSpread",
              "name": "contentCoverImageContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "homeSecondaryV2ContentItemContent"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "entityLink"
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "QueueItemsEdge",
  "abstractKey": null
};

(node as any).hash = "b9ec4013378814c07185592d21d51fd4";

export default node;
